
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {connect} from 'react-redux';
import Navbar from "../components/navigation/Navbar";
import {get_strellatv} from "../redux/actions/home";
import {useEffect} from "react";

const Layout = (props) => {

    useEffect(() => {
        if (!props.strellatv) {
            props.get_strellatv();
        }
    }, []);


    return (
        <div>
            <Navbar/>
            <ToastContainer autoClose={5000}/>
            {props.children}
        </div>
    )
}

const mapStateToProps = state => ({
    strellatv: state.Home.strellatv,
})

export default connect(mapStateToProps, {
    get_strellatv
})(Layout)
